{
  "id": "gold-mine",
  "role": "gold-mine",
  "width": 3,
  "height": 3,
  "dropOff": [],
  "mine": "gold",
  "supplyProvided": 0,
  "trains": [],
  "cost": {
    "gold": 0,
    "lumber": 0
  },
  "buildTicks": 0
}
